var React = require('react');

function ContactIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.165 21.671l1.178-4.595c1.268 1.939.857 1.636 3.81 4.242l-4.988.353z","fill":"#6B3FFC","key":0}),React.createElement("circle",{"cx":"13","cy":"12","r":"11.25","stroke":"#6B3FFC","strokeWidth":"1.5","key":1}),React.createElement("path",{"stroke":"#6B3FFC","d":"M9 7.5h8m-10 4h12m-10 4h8","key":2})]);
}

ContactIcon.defaultProps = {"width":"25","height":"24","fill":"none"};

module.exports = ContactIcon;

ContactIcon.default = ContactIcon;
